'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth, useGetGiftsPendingCount } from '@morfi/backend-sdk-v2/client';

/**
 * Reads the caller's pending gift count for the header badge (US-7, FR-057).
 *
 * v2 SDK: declared in `sdk.manifest.yml` with the realtime recipe
 *   add: { pendingCount: direction, helper: applyPendingCountDelta }
 *   add: { pendingValue: amountD6, helper: applyPendingValueDelta }
 * on `morfi.user.{userId}.gift.v0`. The helpers apply ±1 / ±amount
 * deltas in-place — zero refetches on the badge.
 *
 * Wrapper preserves the legacy v1 `{ data, status }` shape so the
 * `<PendingGiftsBadge>` callsite needs no change.
 */
export function usePendingGiftCount() {
  const $ = _c(6);
  const {
    user
  } = useAuth();
  let t0;
  if ($[0] !== user) {
    t0 = {
      ...(user?.id !== undefined ? {
        userId: user.id
      } : {})
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const q = useGetGiftsPendingCount(t0);
  const status = q.isPending ? "pending" : q.isError ? "error" : "success";
  let t1;
  if ($[2] !== q.data || $[3] !== q.error || $[4] !== status) {
    t1 = {
      data: q.data,
      status,
      error: q.error
    };
    $[2] = q.data;
    $[3] = q.error;
    $[4] = status;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}